/// <amd-module name="Artifacts/Ivy/components/IvyDevelopment" />
import * as IvyRes from "Artifacts/Ivy/Resources";
import { PackageAttribute } from "Artifacts/Package/components/package-details-common/PackageAttribute";
import { IProjectAttribute } from "Artifacts/Package/components/package-details-common/PackageDevelopment";
import { ExternalLink } from "Artifacts/Root/components/ExternalLink";
import { CustomerIntelligenceHelper } from "Artifacts/Root/helpers/CustomerIntelligenceHelper";
import { htmlEncode } from "Artifacts/Root/helpers/HtmlHelper";
import { isSafeProtocol } from "Artifacts/Root/helpers/UrlHelper";
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";
import { Icon } from "VSSUI/Icon";
import { Tooltip } from "VSSUI/TooltipEx";

export interface IIvyDevelopmentProps {
  pageContext: IVssPageContext;
  feedId: string;
  normalizedName: string;
  normalizedVersion: string;
  projectConfigurations: IProjectAttribute[] | null;
  projectAttributes: IProjectAttribute[] | null;
}

export class IvyDevelopment extends React.PureComponent<IIvyDevelopmentProps> {
  public render(): JSX.Element {
    if (!this.showDevelopment()) {
      return <div />;
    }
    return (
      <div className="ivy-development">
        <PackageAttribute title={IvyRes.IvyAttributes_DevelopmentTitle}>
          {this.props.projectAttributes && this.props.projectAttributes.length > 0 && (
            <div>
              <div className="package-group-header" role="heading" aria-level={3}>
                {IvyRes.IvyDevelopment_ProjectHeading}
              </div>
              {this.props.projectAttributes.map((attribute: IProjectAttribute, index: number) => {
                return (
                  <div className="package-attribute-item" key={index}>
                    <Tooltip text={attribute.text}>
                      <div>
                        <span className={"package-attribute-item-icon "}>
                          <Icon iconName={attribute.iconClass} />
                        </span>
                        {isSafeProtocol(attribute.url || "") ? (
                          <ExternalLink
                            pageContext={this.props.pageContext}
                            href={htmlEncode(attribute.url || "")}
                            onClick={() =>
                              CustomerIntelligenceHelper.publishEvent(
                                this.props.pageContext,
                                attribute.onClickCiFeature || "",
                              )
                            }
                          >
                            {attribute.text}
                            <Icon iconName="NavigateExternalInline" />
                          </ExternalLink>
                        ) : (
                          <label className="project-attibute-text">{attribute.text}</label>
                        )}
                      </div>
                    </Tooltip>
                  </div>
                );
              })}
            </div>
          )}
          {this.props.projectConfigurations && this.props.projectConfigurations.length > 0 && (
            <div>
              <div className="package-group-spacer" />
              <div className="package-group-header" role="heading" aria-level={3}>
                {IvyRes.IvyDevelopment_ConfigurationsHeading}
              </div>
              {this.props.projectConfigurations.map((config: IProjectAttribute) => {
                return (
                  <div className="package-attribute-item" key={config.text}>
                    <Tooltip text={config.text}>
                      <label className="project-attibute-text">{config.text}</label>
                    </Tooltip>
                  </div>
                );
              })}
            </div>
          )}
        </PackageAttribute>
      </div>
    );
  }

  private showDevelopment(): boolean {
    return (
      (this.props.projectAttributes !== null && this.props.projectAttributes.length > 0) ||
      (this.props.projectConfigurations !== null && this.props.projectConfigurations.length > 0)
    );
  }
}
